const address = {
	name: 'Address',
	fields: {
		street: 'Street',
		zip: 'ZIP Code | ZIP Code',
		city: 'City | City',
		country: 'Country',
	},
}

export default address
